import type { FC, ReactNode } from 'react';
import { cx } from '../../utils/cx';
import styles from './Card.module.css';

export interface CardProps {
  children: ReactNode;
  interactive?: boolean;
  featured?: boolean;
  className?: string;
}

export const Card: FC<CardProps> = ({
  children,
  interactive,
  featured,
  className,
}) => (
  <div
    className={cx(styles.card, className)}
    data-interactive={interactive || undefined}
    data-featured={featured || undefined}
  >
    {children}
  </div>
);
